// Dashboard data
export const dashboardData = {
	state: {
		userTypes: null,
		totalEmissions: null,
		totalDistance: null,
		totalTime: null,
		totalBenefitsPerLevel: null,
		activeUsers: null,
		userEvolution: null,
		userEvolutionWeekRange: null,
		activeUsersStats: null,
		activeUsersHeatmap: null,
		userZoneActivity: null,
		benefitInformation: null,
		benefitPerformance: null,
		postsGeneral: null
	},
	reducers: {
		setUserTypes(state, payload) {
			return {
				...state,
				userTypes: payload,
			};
		},
		setTotalEmissions(state, payload) {
			return {
				...state,
				totalEmissions: payload,
			};
		},
		setTotalDistance(state, payload) {
			return {
				...state,
				totalDistance: payload,
			};
		},
		setTotalTime(state, payload) {
			return {
				...state,
				totalTime: payload,
			};
		},
		setTotalBenefitsPerLevel(state, payload) {
			return {
				...state,
				totalBenefitsPerLevel: payload,
			};
		},
		setActiveUsers(state, payload) {
			return {
				...state,
				activeUsers: payload,
			};
		},
		setUserEvolution(state, payload) {
			return {
				...state,
				userEvolution: payload,
			};
		},
		setUserEvolutionWeekRange(state, payload) {
			return {
				...state,
				userEvolutionWeekRange: payload,
			};
		},
		setActiveUsersStats(state, payload) {
			return {
				...state,
				activeUsersStats: payload,
			};
		},
		setActiveUsersHeatmap(state, payload) {
			return {
				...state,
				activeUsersHeatmap: payload,
			};
		},
		setUserZoneActivity(state, payload) {
			return {
				...state,
				userZoneActivity: payload,
			};
		},
		setBenefitInformation(state, payload) {
			return {
				...state,
				benefitInformation: payload,
			};
		},
		setBenefitPerformance(state, payload) {
			return {
				...state,
				benefitPerformance: payload,
			};
		},
		setPostsGeneral(state, payload) {
			return {
				...state,
				postsGeneral: payload,
			};
		},
		resetState(state, payload) {
			return {
				userTypes: null,
				totalEmissions: null,
				totalDistance: null,
				totalTime: null,
				totalBenefitsPerLevel: null,
				activeUsers: null,
				userEvolution: null,
				userEvolutionWeekRange: null,
				activeUsersStats: null,
				activeUsersHeatmap: null,
				userZoneActivity: null,
				benefitInformation: null,
				benefitPerformance: null,
				postsGeneral: null
			};
		},
	},
	effects: (dispatch) => ({
		async setDataAsync(payload, rootState) {
			await new Promise((resolve) => resolve);
			dispatch.dashboardData.setUserTypes(payload);
			dispatch.dashboardData.setTotalEmissions(payload);
			dispatch.dashboardData.setTotalDistance(payload);
			dispatch.dashboardData.setTotalTime(payload);
			dispatch.dashboardData.setTotalBenefitsPerLevel(payload);
			dispatch.dashboardData.setActiveUsers(payload);
			dispatch.dashboardData.setUserEvolution(payload);
			dispatch.dashboardData.setUserEvolutionWeekRange(payload);
			dispatch.dashboardData.setActiveUsersStats(payload);
			dispatch.dashboardData.setActiveUsersHeatmap(payload);
			dispatch.dashboardData.setUserZoneActivity(payload);
			dispatch.dashboardData.setBenefitInformation(payload);
			dispatch.dashboardData.setBenefitPerformance(payload);
			dispatch.dashboardData.setPostsGeneral(payload);
			dispatch.dashboardData.resetState(payload);
		},
	}),
}
